import { observable } from 'mobx';
import { AbstractModel, AbstractModelOptions } from '../stores/models/abstract/AbstractModelStore';
import { ImageModel, ImageModelData } from './ImageModel';
import { ResourceImages } from '@foxbun/lib-goferal-types';

export abstract class ResourceModel<T extends ResourceImages> extends AbstractModel<T> {
  @observable
  accessor image: ImageModel | null = null;

  @observable
  accessor headerImage: ImageModel | null = null;

  constructor(options: AbstractModelOptions<T>) {
    super(options);
  }

  protected createMaybeImageModel(data: ImageModelData) {
    if (!data._id || !data.url) {
      return null;
    }
    return this.createImageModel(data);
  }

  protected createImageModel(data: ImageModelData): ImageModel {
    return new ImageModel(data);
  }

  setData(data: T) {
    super.setData(data);
    this.image = this.createMaybeImageModel({
      _id: data.image_id,
      url: data.image_url
    });
    this.headerImage = this.createMaybeImageModel({ _id: data.header_image_id, url: data.header_image_url });
  }
}
